export interface IFamilyVoucherScreeningTransactionDetails {
    Id: number,
    donorCenter: string,
    donorCenterAlias: string,
    donorAlias: string,
    fileName: string,
    createdDate: string,
    completedDate: string,
    requestedDate: string
}
